import { Persona } from "./Persona";

export class Denuncia {
  constructor(
    denunciaId = 0,
    consecutivo = "",
    fechaDeRecepcion = null,    
    numeroDeExpedienteRelativo = "",
    tipoDeActoReclamadoId = null,
    detallesDeActoReclamado = "",
    tipoDeEstadoDeAdmisionId = null,
    observaciones = "",
    rutaArchivo = "",
    tipoDeCalificacionId = null,
    fechaDeInforme = null,
    fechaDeDevolucion = null,
    usuarioRegistroId = null,
    fechaDeRegistro = null,
    tipoDocumentoId = null,
    activo = null,
    tipoDeActoReclamado = null,
    tipoDeEstadoDeAdmision = null,
    tipoDeCalificacion = null,
    tipoDeDocumento = null,
    personas = null,
    acuerdos = null,
  ) {
    this.denunciaId = denunciaId,
      this.consecutivo = consecutivo;
    this.fechaDeRecepcion = fechaDeRecepcion;
    this.numeroDeExpedienteRelativo = numeroDeExpedienteRelativo;
    this.tipoDeActoReclamadoId = tipoDeActoReclamadoId;
    this.detallesDeActoReclamado = detallesDeActoReclamado;
    this.tipoDeEstadoDeAdmisionId = tipoDeEstadoDeAdmisionId;
    this.observaciones = observaciones;
    this.rutaArchivo = rutaArchivo;
    this.tipoDeCalificacionId = tipoDeCalificacionId;
    this.fechaDeInforme = fechaDeInforme;
    this.fechaDeDevolucion = fechaDeDevolucion;
    this.usuarioRegistroId = usuarioRegistroId;
    this.fechaDeRegistro = fechaDeRegistro;
    this.tipoDocumentoId = tipoDocumentoId;
    this.activo = activo;    
    this.tipoDeActoReclamado = tipoDeActoReclamado;
    this.tipoDeEstadoDeAdmision = tipoDeEstadoDeAdmision;
    this.tipoDeCalificacion = tipoDeCalificacion;
    this.tipoDeDocumento = tipoDeDocumento;
    this.personas = personas;
    this.acuerdos = acuerdos;
  }
  constructorObjeto(denunciaObject) {
    this.denunciaId = denunciaObject.denunciaId,
      this.consecutivo = denunciaObject.consecutivo;
    this.fechaDeRecepcion = denunciaObject.fechaDeRecepcion.substring(0, 10);    
    this.numeroDeExpedienteRelativo = denunciaObject.numeroDeExpedienteRelativo;
    this.tipoDeActoReclamadoId = denunciaObject.tipoDeActoReclamadoId;
    this.detallesDeActoReclamado = denunciaObject.detallesDeActoReclamado;
    this.tipoDeEstadoDeAdmisionId = denunciaObject.tipoDeEstadoDeAdmisionId;
    this.observaciones = denunciaObject.observaciones;
    this.rutaArchivo = denunciaObject.rutaArchivo;
    this.tipoDeCalificacionId = denunciaObject.tipoDeCalificacionId;
    this.fechaDeInforme = (denunciaObject.fechaDeInforme)? denunciaObject.fechaDeInforme.substring(0, 10) : null;
    this.fechaDeDevolucion = (denunciaObject.fechaDeDevolucion)? denunciaObject.fechaDeDevolucion.substring(0, 10) : null;
    this.usuarioRegistroId = denunciaObject.usuarioRegistroId;
    this.fechaDeRegistro = denunciaObject.fechaDeRegistro;
    this.tipoDocumentoId = denunciaObject.tipoDocumentoId;
    this.activo = denunciaObject.activo;
    this.tipoDeActoReclamado = denunciaObject.tipoDeActoReclamado;
    this.tipoDeEstadoDeAdmision = denunciaObject.tipoDeEstadoDeAdmision;
    this.tipoDeCalificacion = denunciaObject.tipoDeCalificacion;
    this.tipoDeDocumento = denunciaObject.tipoDeDocumento;
    this.personas = (denunciaObject.personas) ? denunciaObject.personas.map(persona => {
      let nuevaPersona = new Persona();
      nuevaPersona.constructorObjeto(persona);
      return nuevaPersona;
    }) : [];
    this.acuerdos = denunciaObject.acuerdos;
  }
  cargarDatosParaFormulario(args) {
    if (args.includes('insertar-denuncia')) {
      this.activo = true;
      this.tipoDocumentoId = 1;
      this.tipoDeActoReclamadoId = (this.tipoDeActoReclamadoId == -1) ? null : this.tipoDeActoReclamadoId;
    }
    if (args.includes('insertar-datos-finales')) {
      this.tipoDeCalificacionId = (this.tipoDeCalificacionId == -1) ? null : this.tipoDeCalificacionId;
     }
    if (args.includes('datos-generales')) {
      this.fechaDeRecepcion = new Date().toISOString().split("T")[0];
      this.tipoDeActoReclamadoId = -1;
      this.tipoDeEstadoDeAdmisionId = 1;
      this.personas = []
    }
    if (args.includes('datos-finales')) {
      this.fechaDeInforme = new Date().toISOString().split("T")[0];
      this.tipoDeCalificacionId = -1;
     }
   }
}



// WEBPACK FOOTER //
// ./src/components/SIFA/Comun/Modelos/Denuncia.js